import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, Modal, Spin } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { doSignInWithEmailAndPassword } from '../firebase/auth'; // Función para inicio de sesión
import { doPasswordReset } from '../firebase/auth'; // Función para restablecer la contraseña
import '../assets/styles/Login.css';

const { Title, Text } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false); // Estado para controlar el modal
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const onFinish = async (values) => {
    const { email, password } = values;

    try {
      setLoading(true);
      // Llamamos a la función para iniciar sesión
      const userCredential = await doSignInWithEmailAndPassword(email, password);
      console.log('Inicio de sesión exitoso:', userCredential);
      message.success('Inicio de sesión exitoso');
      window.location.href = '/'; // Redirigir a la página principal o dashboard
    } catch (error) {
      message.error('Error al iniciar sesión, datos incorrectos');
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setIsModalVisible(true); // Mostrar el modal cuando se hace clic en "Olvidaste tu contraseña"
  };

  const handleCancelModal = () => {
    setIsModalVisible(false); // Cerrar el modal
  };

  const handleSendRecoveryEmail = async (values) => {
    const { email } = values;

    if (!email) {
      message.error('Por favor ingresa tu correo electrónico para recuperar la contraseña');
      return;
    }

    try {
      setResetLoading(true);
      // Enviar el correo de recuperación de contraseña
      await doPasswordReset(email);
      message.success('Correo de recuperación enviado. Revisa tu bandeja de entrada.');
      setIsModalVisible(false); // Cerrar el modal después de enviar el correo
      setResetLoading(false);
    } catch (error) {
      message.error('Error al enviar el correo de recuperación: ' + error.message);
      setResetLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form-container">
          <Title level={2} className="login-title">Bienvenido de vuelta</Title>
          <Text type="secondary" className="login-subtitle">Nos alegra verte de nuevo. Inicia sesión para continuar.</Text>

          <Form
            form={form}
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: '' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Correo electrónico"
                className="login-input"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Contraseña"
                className="login-input"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>
            <Form.Item>
              <button 
                type="primary" 
                htmlType="submit" 
                className="login-button"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spin size="small" style={{ marginRight: '8px' }} />
                    Iniciando sesión...
                  </>
                ) : (
                  'Iniciar sesión'
                )}
              </button>
            </Form.Item>
          </Form>

          <Button type="link" onClick={handleForgotPassword} className="forgot-password-link">
            ¿Olvidaste tu contraseña?
          </Button>

          <Text type="secondary" className="login-footer">
            ¿No tienes una cuenta? <a href="/signup">Regístrate</a>
          </Text>
        </div>
      </div>

      {/* Modal para recuperar la contraseña */}
      <Modal
        title="Recuperar contraseña"
        visible={isModalVisible}
        onCancel={handleCancelModal}
        footer={null}
        destroyOnClose
      >
        <Form
          name="forgot_password"
          onFinish={handleSendRecoveryEmail}
          initialValues={{ email: '' }}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Por favor ingresa tu correo electrónico' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Correo electrónico"
              className="login-input"
            />
          </Form.Item>
          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-button"
              loading={resetLoading}
              disabled={resetLoading}
            >
              {resetLoading ? 'Enviando...' : 'Enviar correo de recuperación'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;
